export default __webpack_public_path__ + "static/media/GONZALO ARAYA.8a9f6eae.jpg";